import { render, staticRenderFns } from "./scaq.vue?vue&type=template&id=5d7e4a27&scoped=true&"
import script from "./scaq.vue?vue&type=script&lang=js&"
export * from "./scaq.vue?vue&type=script&lang=js&"
import style0 from "./scaq.vue?vue&type=style&index=0&id=5d7e4a27&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d7e4a27",
  null
  
)

export default component.exports